import { ButtonCheckbox, SaveableCard } from "@jasper/forms";
import { Group, Stack, Text } from "@mantine/core";
import { withForm } from "../../../hooks/preferenceForm";
import { usePreferenceCardSave } from "../../../hooks/usePreferenceCardSave";
import { getGeneralPreferenceDefaults } from "../generalPreferenceForm";

const OCCLUSIONS = ["Idéale", "Sous-occlusion", "Sur-occlusion"];
const CONTACT_POINTS = ["Légers", "Moyens", "Serrés"];
const CERVICAL_LIMITS = [
  "Supra-gingivale",
  "Juxta-gingivale",
  "Sous-gingivale",
];

export const OcclusionPreferences = withForm({
  defaultValues: getGeneralPreferenceDefaults(undefined),
  render: function Render({ form }) {
    const { status, save } = usePreferenceCardSave(form, [
      "occlusion",
      "contactPoints",
      "cervicalLimit",
    ]);

    return (
      <SaveableCard
        title="Occlusion & contacts"
        description="Valeurs appliquées par défaut aux prothèses fixes"
        status={status}
        onSave={save}
      >
        <Stack gap="s3">
          <>
            <Text variant="strong">Occlusion</Text>
            <form.Field name="occlusion">
              {field => (
                <Group>
                  {OCCLUSIONS.map(occlusion => (
                    <ButtonCheckbox
                      key={occlusion}
                      id={occlusion}
                      isActive={field.state.value === occlusion}
                      onClick={() => field.handleChange(occlusion)}
                    >
                      {occlusion}
                    </ButtonCheckbox>
                  ))}
                </Group>
              )}
            </form.Field>
          </>
          <>
            <Text variant="strong">Points de contact</Text>
            <form.Field name="contactPoints">
              {field => (
                <Group>
                  {CONTACT_POINTS.map(contactPoint => (
                    <ButtonCheckbox
                      key={contactPoint}
                      id={contactPoint}
                      isActive={field.state.value === contactPoint}
                      onClick={() => field.handleChange(contactPoint)}
                    >
                      {contactPoint}
                    </ButtonCheckbox>
                  ))}
                </Group>
              )}
            </form.Field>
          </>
          <>
            <Text variant="strong">Limite cervicale</Text>
            <form.Field name="cervicalLimit">
              {field => (
                <Group>
                  {CERVICAL_LIMITS.map(cervicalLimit => (
                    <ButtonCheckbox
                      key={cervicalLimit}
                      id={cervicalLimit}
                      isActive={field.state.value === cervicalLimit}
                      onClick={() => field.handleChange(cervicalLimit)}
                    >
                      {cervicalLimit}
                    </ButtonCheckbox>
                  ))}
                </Group>
              )}
            </form.Field>
          </>
        </Stack>
      </SaveableCard>
    );
  },
});
